import React from "react";
import {
  FaHome,
  FaProjectDiagram,
  FaCalculator,
  FaRupeeSign,
  FaTasks,
  FaClipboardCheck,
  FaUserTie,
} from "react-icons/fa";
import {
  MdLock,
  MdWork,
  MdOutlineSubscriptions,
  MdWorkOff,
  MdAssignmentTurnedIn,
  MdAdminPanelSettings,
} from "react-icons/md";
import { FiShield, FiSliders } from "react-icons/fi";
import PersonIcon from "@mui/icons-material/Person";
import { FiUsers, FiTag, FiGift, FiLock, FiKey, FiUserCheck } from "react-icons/fi";

// ================= AUTH =================
import SignIn from "views/auth/SignIn";
import Register from "views/auth/Register";

// ================= SUBSCRIPTION =================
import SubscriptionPlans from "views/subscription/SubscriptionPlans";

// ================= ADMIN =================
import Dashboard from "views/admin/Dasboard/Dashboard";

// ================= PLANS superadmin =================
import Plans from "views/admin/plans/Plans";

// ================= ROLE management superadmin =================
import Role from "views/admin/roleManagement/role/Role";
import Permission from "views/admin/roleManagement/permission/Permission";
import RoleAccess from "views/admin/roleManagement/roleAccess/RoleAccess";

// ================ COMPANY =================
import CompanyDashboard from "views/company/dashboard/CompanyDashboard";

import Employee from "views/company/userManagement/employee/Employee";
import Department from "views/company/userManagement/department/Department";
import Designation from "views/company/userManagement/designation/Designation";

import Profile from "views/company/profile/Profile";

import LeaveDetails from "views/company/leaveManagement/leaveDetails/LeaveDetails";
import LeaveType from "views/company/leaveManagement/leaveType/LeaveType";
import Holiday from "views/company/leaveManagement/holiday/Holiday";

import SalaryStructure from "views/company/payrollManagement/salaryStructure/SalaryStructure";
import SalaryConfiguration from "views/company/payrollManagement/salaryConfiguration/SalaryConfiguration";
import ProcessPayroll from "views/company/payrollManagement/processPayroll/ProcessPayroll";

import AttendanceRecords from "views/company/attendanceManagement/attendanceRecords/AttendanceRecords";

import Project from "views/company/projectManagement/project/Project";
import Task from "views/company/projectManagement/task/Task";

import RolePermission from "views/company/roleManagement/rolePermission";
import CompanyRole from "views/company/roleManagement/companyRole";
import EmployeeRoles from "views/company/roleManagement/employeeRole";

// ================= GROUP ICONS =================
export const groupIcons = {
  Dashboard: <FaHome className="h-6 w-6" />,
  // "User Management": <MdManageAccounts className="h-6 w-6" />,
  Plans: <MdOutlineSubscriptions className="h-6 w-6" />,
  // "Contact Us": <FiMessageSquare className="h-6 w-6" />,
  "Attendance Management": <FaClipboardCheck className="" h-6 w-6 />,
};

// ================= ROUTES =================
// eslint-disable-next-line no-sparse-arrays
const routes = [
  // DASHBOARD superadmin
  {
    name: "Dashboard",
    layout: "/admin",
    path: "dashboard",
    icon: <FaHome className="h-5 w-5" />,
    component: <Dashboard />,
    showInSidebar: true,
    group: "Dashboard",
  },

  // ================= PLANS superadmin=================
  {
    name: "Plans",
    layout: "/admin",
    path: "plans",
    icon: <MdOutlineSubscriptions className="h-5 w-5" />,
    component: <Plans />,
    showInSidebar: true,
    group: "Plans",
  },

  // ================= ROLE superadmin=================
  {
    name: "Role",
    layout: "/admin",
    path: "role",
    icon: <MdAssignmentTurnedIn className="h-5 w-5" />,
    component: <Role />,
    showInSidebar: true,
    group: "Role Management",
  },

  // ================= PERMISSION superadmin=================
  {
    name: "Permission",
    layout: "/admin",
    path: "permission",
    icon: <FiLock className="h-5 w-5" />,
    component: <Permission />,
    showInSidebar: true,
    group: "Role Management",
  },

  // ================= PERMISSION superadmin=================
  {
    name: "Role Access",
    layout: "/admin",
    path: "role-access",
    icon: <MdAdminPanelSettings className="h-5 w-5" />,
    component: <RoleAccess />,
    showInSidebar: true,
    group: "Role Management",
  },

  // ================= SUBSCRIPTION superadmin=================
  {
    name: "Subscription Plans",
    layout: "/subscription",
    path: "plans",
    component: <SubscriptionPlans />,
    showInSidebar: false,
  },
  // ================= AUTH =================
  {
    name: "Sign In",
    layout: "/auth",
    path: "sign-in",
    icon: <MdLock className="h-5 w-5" />,
    component: <SignIn />,
    showInSidebar: false,
  },
  {
    name: "Register",
    layout: "/auth",
    path: "register",
    icon: <MdLock className="h-5 w-5" />,
    component: <Register />,
    showInSidebar: false,
  },
  // ================= COMPANY USER ROUTES =================
  {
    name: "Dashboard",
    layout: "/company",
    path: "dashboard",
    icon: <FaHome className="h-5 w-5" />,
    component: <CompanyDashboard />,
    showInSidebar: true,
    group: "Dashboard",
  },
  {
    name: "Profile",
    layout: "/company",
    path: "profile",
    icon: <PersonIcon />,
    component: <Profile />,
    showInSidebar: false,
    group: "User",
  },

  // ================ usermanagement company =================
  {
    name: "Employee",
    layout: "/company",
    path: "employee",
    icon: <FiUsers className="h-5 w-5" />,
    component: <Employee />,
    showInSidebar: true,
    group: "User Management",
  },
  {
    name: "Department",
    layout: "/company",
    path: "department",
    icon: <MdWork className="h-5 w-5" />,
    component: <Department />,
    showInSidebar: true,
    group: "User Management",
  },
  {
    name: "Designation",
    layout: "/company",
    path: "designation",
    icon: <FaUserTie className="h-5 w-5" />,
    component: <Designation />,
    showInSidebar: true,
    group: "User Management",
  },

  ,
  // ================ attendance management company =================
  {
    name: "Attendance Records",
    layout: "/company",
    path: "attendance-records",
    icon: <FaClipboardCheck className="h-5 w-5" />,
    component: <AttendanceRecords />,
    showInSidebar: true,
    group: "Attendance Management",
  },

  // ================ leave management company =================
  {
    name: "Leave Details",
    layout: "/company",
    path: "leave-details",
    icon: <MdWorkOff className="h-5 w-5" />,
    component: <LeaveDetails />,
    showInSidebar: true,
    group: "Leave Management",
  },
  {
    name: "Leave Type",
    layout: "/company",
    path: "leave-type",
    icon: <FiTag className="h-5 w-5" />,
    component: <LeaveType />,
    showInSidebar: true,
    group: "Leave Management",
  },
  {
    name: "Holiday",
    layout: "/company",
    path: "holiday",
    icon: <FiGift className="h-5 w-5" />,
    component: <Holiday />,
    showInSidebar: true,
    group: "Leave Management",
  },

  // ================ payroll management company =================
  {
    name: "Salary Structure",
    layout: "/company",
    path: "salary-structure",
    icon: <FaCalculator className="h-5 w-5" />,
    component: <SalaryStructure />,
    showInSidebar: true,
    group: "Payroll Management",
  },
  {
    name: "Salary Configuration",
    layout: "/company",
    path: "salary-configuration",
    icon: <FaProjectDiagram className="h-5 w-5" />,
    component: <SalaryConfiguration />,
    showInSidebar: true,
    group: "Payroll Management",
  },
  {
    name: "Process Payroll",
    layout: "/company",
    path: "process-payroll",
    icon: <FaRupeeSign className="h-5 w-5" />,
    component: <ProcessPayroll />,
    showInSidebar: true,
    group: "Payroll Management",
  },

  // ================ project management company =================
  {
    name: "Projects",
    layout: "/company",
    path: "projects",
    icon: <FaProjectDiagram className="h-5 w-5" />,
    component: <Project />,
    showInSidebar: true,
    group: "Project Management",
  },
  {
    name: "Tasks",
    layout: "/company",
    path: "tasks",
    icon: <FaTasks className="h-5 w-5" />,
    component: <Task />,
    showInSidebar: true,
    group: "Project Management",
  },

  // ================ role management company =================
  {
    name: "Roles",
    layout: "/company",
    path: "company-role",
    icon: <FiSliders className="h-5 w-5" />,
    component: <CompanyRole />,
    showInSidebar: true,
    group: "Role Management",
  },
  {
    name: "Role Permissions",
    layout: "/company",
    path: "assign-roles",
    icon: <FiKey className="h-5 w-5" />,
    component: <RolePermission />,
    showInSidebar: true,
    group: "Role Management",
  },
  {
    name: "Employee Roles",
    layout: "/company",
    path: "employee-roles",
    icon: <FiUserCheck className="h-5 w-5" />,
    component: <EmployeeRoles />,
    showInSidebar: true,
    group: "Role Management",
  },
];

export default routes;
